/**
 * Shared root className for full-bleed list/detail pages that render directly in
 * the app-shell <main> (which is `pt-0` on every route — see AppShell.tsx).
 *
 * WHY the margins:
 * - `-mt-4` tucks the page under the mobile sticky logo bar (ErpLayout) so the
 *   first row isn't cramped against it.
 * - `lg:mt-0` cancels that pull on desktop, where <main> has NO top padding to
 *   cancel. Without it the `-mt-4` over-pulls the page ~17px ABOVE the viewport
 *   and clips the toolbar/title at the top edge.
 * - `-mb-6` lets the page run to the bottom edge of the scroll area.
 *
 * Use this for any page whose root is a `min-h-screen` white shell sitting in
 * <main>. See docs/frontend/detail-pages/full-bleed-page-top-spacing.md.
 */
export const LIST_PAGE_SHELL =
  "min-h-screen bg-white dark:bg-neutral-950 -mt-4 lg:mt-0 -mb-6";
